export default {
    title: "Estúdio de demonstração digital",
    support: "Apoiar",
    dashboard: "Painel"
}